"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatBytes = void 0;
function formatBytes(bytes, decimals) {
    if (bytes === 0) {
        return "0 Bytes";
    }
    var k = 1000;
    var dm = decimals || 2;
    var sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    // tslint:disable-next-line:prefer-template
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}
exports.formatBytes = formatBytes;
